import React, { useState, useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

const btn = 'px-2 py-1 text-sm rounded border border-white/10 text-gray-200 hover:bg-white/10';

const RichTextEditor = ({ value, onChange }) => {
  const [mode, setMode] = useState('visual'); // 'visual' | 'code'

  const editor = useEditor({
    extensions: [StarterKit],
    content: value || '',
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
  });

  // Sync external value into the editor when it changes while in visual mode
  // (e.g. when the edit page finishes loading the post).
  useEffect(() => {
    if (editor && mode === 'visual' && value !== editor.getHTML()) {
      editor.commands.setContent(value || '', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, editor]);

  const switchTo = (next) => {
    if (next === 'visual' && editor) {
      editor.commands.setContent(value || '', false);
    }
    setMode(next);
  };

  if (!editor) return null;

  return (
    <div className="border border-white/10 rounded-lg overflow-hidden">
      <div className="flex flex-wrap gap-1 p-2 bg-slate-800/60 border-b border-white/10">
        {mode === 'visual' && (
          <>
            <button type="button" className={btn} onClick={() => editor.chain().focus().toggleBold().run()}>B</button>
            <button type="button" className={btn} onClick={() => editor.chain().focus().toggleItalic().run()}>I</button>
            <button type="button" className={btn} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>H2</button>
            <button type="button" className={btn} onClick={() => editor.chain().focus().toggleBulletList().run()}>• Lista</button>
          </>
        )}
        <div className="ml-auto flex gap-1">
          <button type="button" className={`${btn} ${mode === 'visual' ? 'bg-white/10' : ''}`} onClick={() => switchTo('visual')}>Visual</button>
          <button type="button" className={`${btn} ${mode === 'code' ? 'bg-white/10' : ''}`} onClick={() => switchTo('code')}>HTML</button>
        </div>
      </div>

      {mode === 'visual' ? (
        <EditorContent
          editor={editor}
          className="prose prose-invert max-w-none p-3 min-h-[240px] bg-slate-900/40 text-white focus:outline-none [&_.ProseMirror]:outline-none [&_.ProseMirror]:min-h-[220px]"
        />
      ) : (
        <textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          rows={14}
          spellCheck={false}
          className="w-full p-3 bg-slate-900/40 text-green-200 font-mono text-sm focus:outline-none"
          placeholder="Cole ou edite o HTML puro aqui (embeds, iframes, etc.)"
        />
      )}
    </div>
  );
};

export default RichTextEditor;
